import { useContainer } from '../../useContainer';
import { AbsenceReportApi } from '../../../api';
import { AbsenceReportApiResponse } from '../../../api/AbsenceReportApi';
import useAbsenceReportPolling from './useAbsenceReportPolling';

type AbsenceOverviewData = AbsenceReportApiResponse.GetOverview['body'];

const useHttpGetAbsenceOverview = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    return useAbsenceReportPolling<AbsenceOverviewData>(handlers => absenceReportApi.getOverview(handlers), { dataAvailable: false });
};

export default useHttpGetAbsenceOverview;
